import { render } from "./recommended-products.vue?vue&type=template&id=88cd503c"
import script from "./recommended-products.vue?vue&type=script&lang=js"
export * from "./recommended-products.vue?vue&type=script&lang=js"

import "./recommended-products.vue?vue&type=style&index=0&id=88cd503c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__